export default __webpack_public_path__ + "static/media/top-k-4.bf79b267.jpg";